module.exports = __webpack_public_path__ + "static/img/s200_c.e66cbf9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/devices/s200_c.png
// module id = mWTU
// module chunks = 0